import React from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { SafetyCertificateOutlined } from '@ant-design/icons';
import RibbonButton from 'common/components/button/RibbonButton';
import useToggleActiveRibbon from './hook';

import { useGetProductFullView } from 'hooks';
import { useSsoProductParams } from 'hooks/useSso';

import Messages from 'i18n/messages/home';

const Subscription = ({ productId }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { productFull } = useGetProductFullView({ productId });

  const { ssoParamUrl: ssoProductParams, productId: ssoProductId } =
    useSsoProductParams();

  const checkActiveContent = () => {
    const path = location?.pathname;
    const regex = /\/product\/subscription\/\d+$/;
    return regex.test(path);
  };

  const isPathActive = checkActiveContent();
  const isActive = useToggleActiveRibbon(isPathActive);

  const handleClick = () => {
    if (productFull?.productId !== undefined) {
      if (isActive) {
        if (ssoProductParams) {
          navigate(`/product/${ssoProductId}/?${ssoProductParams}`);
        } else {
          navigate(`/product/${productFull?.productId}`);
        }
      } else {
        if (ssoProductParams) {
          navigate(`/product/subscription/${ssoProductId}?${ssoProductParams}`);
        } else {
          navigate(`/product/subscription/${productFull?.productId}`);
        }
      }
    }
  };

  return (
    <RibbonButton
      icon={<SafetyCertificateOutlined style={{ height: 26 }} />}
      label={Messages.subscription}
      onClick={handleClick}
      toggle={isPathActive}
      disabled={!productFull?.productId}
    />
  );
};

export default Subscription;
